<template>
  <ModalDialog v-model="isShow" :isInline="isInline" :isInlinePin="isInlinePin">
    <div
      class="field-of-fields"
      :class="isInline || isInlinePin ? '' : 'p-5'"
      slot="dialog-content"
      ref="dialogContainer"
    >
      <div v-if="!isInline && !isInlinePin">
        <h3 v-if="title" class="dialog-title">
          {{ title }}
        </h3>
        <EditLabelSetting
          v-else-if="isAdd"
          title="Edit Heading"
          :modelKey="getCustomizableLabelModelKey('add_item_header')"
          :defaultValue="getLabelByKeys('LABELS.ADD_ITEM', headerSingularForm)"
          classList="dialog-title"
          tagName="h3"
        >
          <i
            class="material-icons edit-builder-icon ml-2"
            slot="after-label"
            v-if="isAgent && field && field.sectionBuilderId"
            @click="$emit('setting')"
          >
            settings
          </i>
        </EditLabelSetting>
        <EditLabelSetting
          v-else-if="!isAdd"
          title="Edit Heading"
          :modelKey="getCustomizableLabelModelKey('edit_item_header')"
          :defaultValue="getLabelByKeys('LABELS.EDIT_ITEM', headerSingularForm)"
          classList="dialog-title"
          tagName="h3"
        >
          <h3
            slot="after-label"
            class="edit-object-title"
            v-if="getObjectTitle()"
          >
            {{ getObjectTitle() }}
          </h3>
          <i
            slot="after-label2"
            class="material-icons edit-builder-icon ml-2"
            v-if="isAgent && field && field.sectionBuilderId"
            @click="$emit('setting')"
          >
            settings
          </i>
        </EditLabelSetting>
        <hr style="margin-bottom: 0" />
      </div>
      <FormGroupRowLayout
        :submitClicked="submitClicked"
        :modelData="userInputData"
        :listFields="listVisibleFields"
        :submitInfo="submitInfo"
        :hasFileAccessControlBtn="false"
      />
      <hr />
      <div class="button-containers">
        <div class="right-side-button">
          <button
            class="submit-button mylisting-button dark-button"
            @click="handleClickSaveButton()"
          >
            {{ getLabelByKeys("BUTTONS.SAVE") }}
          </button>
          <div class="d-inline-block">
            <EditButtonSetting
              v-if="isAdd"
              :modelKey="getCustomizableButtonModelKey('add_and_save')"
              :defaultValue="
                getLabelByKeys(
                  'LABELS.SAVE_AND_ADD_ANOTHER_ITEM',
                  headerSingularForm
                )
              "
              classList="submit-button mylisting-button secondary-button"
              @click="handleClickSaveButton(true)"
            />
          </div>
        </div>
        <div class="left-side-button">
          <div class="delete-btn-container">
            <button
              v-if="!hideDeleteBtn && !isAdd"
              class="mylisting-button danger-button"
              @click="showDeleteDataConfirmDialog()"
              style=""
            >
              {{ getLabelByKeys("BUTTONS.DELETE") }}
            </button>
          </div>
          <div class="cancel-button-container">
            <button
              class="mylisting-button secondary-button cancel-button"
              @click="handleClickCancelButton()"
            >
              {{ getLabelByKeys("BUTTONS.CANCEL") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ModalDialog>
</template>
<script>
/*
This component is used for a dialog (add/edit) objects (reference/children/experience/education...)
 */
import axios from "axios";
import { FORM_TYPE, ACTION_TYPE } from "../../constants/custom-define-type";
import ModalDialog from "./global-dialogs/ModalDialog.vue";
import { mapGetters } from "vuex";

export default {
  name: "ProfileSectionDialog",
  props: {
    header: String,
    name: String,
    user: Object,
    data: Object,
    title: String,
    keyTitles: {
      type: Array,
      default: () => ["name"],
    },
    value: Boolean,
    isAdd: Boolean,
    listFields: Array,
    isSendRequest: {
      type: Boolean,
      default: false,
    },
    api: String,
    /* Title and message of dialog when save successfully */
    submissionContent: Object,
    // List models which is not showed
    listExcludeFields: {
      type: Array,
      default: () => [],
    },
    // The corresponding field of profile builder
    field: {
      type: Object,
      default: () => {},
    },
    // ID of profile builder
    profileBuilderID: Number,
    hideDeleteBtn: {
      type: Boolean,
      default: false,
    },
    submitInfo: Object,
    isInline: {
      type: Boolean,
      default: false,
    },
    isInlinePin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalDialog,
  },
  data() {
    return {
      submitClicked: false,
      ACTION_TYPE: ACTION_TYPE,
      isShow: false,
      userInputData: {},
      hideAllField: false, // Variable to reset listVisibleField
    };
  },
  computed: {
    ...mapGetters(["listExperienceTypes", "language", "isAgent"]),
    accessControlObj() {
      return {
        title: "Access Control",
        listFields: [
          {
            label: "Please select access level scope for this file",
            model: "accessScope",
            type: FORM_TYPE.MULTI_SELECT,
            optionList: [
              {
                label: "Private (Visible to admin and the owner)",
                model: "private",
              },
              {
                label: "Public (Visible to everyone)",
                model: "public",
              },
            ],
            optionLabel: "label",
            optionModel: "model",
          },
        ],
      };
    },
    headerSingularForm() {
      return this.convertToSingularForm(this.header);
    },
    listVisibleFields() {
      if (this.hideAllField) {
        return [];
      }
      if (this.listFields == null) {
        return [];
      }
      if (
        this.name === "Experience" &&
        this.listExperienceTypes &&
        this.listExperienceTypes.length
      ) {
        const typesField = this.listFields.find(
          (field) => field.model === "types"
        );
        if (typesField && !typesField.optionList) {
          typesField.optionList = this.listExperienceTypes;
        }
      }

      return this.listFields.filter(
        (field) => !this.listExcludeFields.includes(field.model)
      );
    },
    isTypeInUsed() {
      if (!this.listFields) {
        return false;
      }
      return this.listFields.some((field) => field.model === "type");
    },
  },
  methods: {
    hideModal() {
      this.isShow = false;
      this.$emit("input", false);
    },
    showModal() {
      this.isShow = true;
    },
    getCustomizableButtonModelKey(key) {
      return `section_${this.profileBuilderID}_${
        this.field ? this.field.sectionBuilderId : ""
      }_${key}_${this.language || ""}`;
    },
    getCustomizableLabelModelKey(key) {
      return `public_advance_setting.section_${this.profileBuilderID}_${
        this.field ? this.field.sectionBuilderId : ""
      }_${key}_${this.language || ""}`;
    },
    getObjectTitle() {
      return this.keyTitles
        .map((titleKey) =>
          this.removeOtherRadioPrefix(this.userInputData[titleKey])
        )
        .join(" ");
    },
    async handleClickSaveButton(addAnother) {
      if (this.userInputData.email) {
        this.userInputData.email = this.userInputData.email.trim();
      }
      if (this.userInputData.email2) {
        this.userInputData.email2 = this.userInputData.email2.trim();
      }
      this.submitClicked = true;
      // Check to show warning for missing fields
      const isContinue = await this.validateBaseInputValues(
        this.userInputData,
        this.listVisibleFields
      );
      if (!isContinue) {
        return;
      }

      console.log(this.userInputData);
      this.$emit("saved", {
        type: this.isAdd ? ACTION_TYPE.ADD : ACTION_TYPE.UPDATE,
        data: { ...this.userInputData },
      });
      if (addAnother) {
        this.showResultDialog({
          ...this.$store.getters.saveAndAddNewObject,
          params: [this.name],
          onCloseCallback: () => {
            this.hideAllField = true;
            this.$nextTick(() => {
              this.hideAllField = false;
            });
            this.submitClicked = false;
            this.userInputData = this.getInitialObject();
            this.$refs.dialogContainer.scrollIntoView();
          },
        });
      } else {
        this.hideModal();
      }
    },
    handleClickCancelButton() {
      if (this.isDisableConfirmCancellation()) {
        this.hideModal();
        return;
      }
      // Check if data is unchanged
      if (
        this.isUnchangedObject(
          this.data,
          this.userInputData,
          this.listVisibleFields
        )
      ) {
        this.hideModal();
        return;
      }
      this.showConfirmDialog({
        ...this.$store.getters.cancelConfirmDialog,
        onAcceptCallback: this.hideModal,
      });
    },
    showDeleteDataConfirmDialog() {
      this.showConfirmDialog({
        ...this.$store.getters["delete" + this.name + "ConfirmDialog"],
        onAcceptCallback: this.deleteData,
      });
    },
    deleteData() {
      this.hideModal();
      this.$emit("saved", { type: ACTION_TYPE.DELETE });
    },
    getInitialObject() {
      const result = {};
      if (!this.listFields) {
        return result;
      }
      const listShareModelFields = this.listFields.filter(
        (field) => field.isShareModel
      );
      listShareModelFields.forEach((field) => {
        result[field.model] = [];
        result[field.model][field.shareModelIndex] = "";
      });
      // Find list of fields with initial values
      const listInitialFields = this.listFields.filter(
        (field) => field.initialValue && field.model
      );
      for (const field of listInitialFields) {
        result[field.model] = field.initialValue;
      }
      return result;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value === true) {
          this.submitClicked = false;
          if (this.data) {
            if (this.isAdd) {
              this.userInputData = this.getInitialObject();
            } else {
              this.userInputData = this.extractSelectedFields(
                this.data,
                this.listFields,
                true
              );
            }
          } else {
            this.userInputData = this.getInitialObject();
          }
          this.showModal();
        } else {
          this.hideModal();
        }
      },
    },
    isShow: {
      immediate: true,
      handler() {
        this.$emit("input", this.isShow);
      },
    },
    data: {
      immediate: true,
      handler() {
        if (
          !this.isAdd &&
          this.isInlinePin &&
          this.listFields &&
          this.listFields.length
        ) {
          this.userInputData = this.extractSelectedFields(
            this.data,
            this.listFields,
            true
          );
        }
      },
    },
  },
};
</script>

<style scoped>
.button-containers {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  margin-top: -8px;
}

.left-side-button {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 8px;
}

.right-side-button {
  flex-grow: 1;
  text-align: right;
}

.danger-button {
  margin-left: 0.5em;
}

.hide-btn-container {
  margin-left: 0.5em;
}

.right-side-button > button {
  margin-top: 8px;
}

@media (max-width: 650px) {
  .button-containers {
    display: block;
    text-align: center;
  }

  .left-side-button {
    display: block;
  }

  .right-side-button {
    text-align: center;
  }

  .danger-button {
    margin-left: 0;
    margin-bottom: 8px;
  }
}

.edit-object-title::before {
  content: " - ";
}
</style>



// WEBPACK FOOTER //
// src/components/common/ProfileSectionDialog.vue